var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6992_31680)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M500 0H0V500H500V0Z",
    fill: "#E1E4F7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.5 239.375C225.104 239.375 239.375 225.104 239.375 207.5C239.375 189.896 225.104 175.625 207.5 175.625C189.896 175.625 175.625 189.896 175.625 207.5C175.625 225.104 189.896 239.375 207.5 239.375ZM196.875 207.5C196.875 201.632 201.632 196.875 207.5 196.875C213.368 196.875 218.125 201.632 218.125 207.5C218.125 213.368 213.368 218.125 207.5 218.125C201.632 218.125 196.875 213.368 196.875 207.5Z",
    fill: "#C5CBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.75 313.75C319.618 313.75 324.375 308.993 324.375 303.125C324.375 297.257 319.618 292.5 313.75 292.5C307.882 292.5 303.125 297.257 303.125 303.125C303.125 308.993 307.882 313.75 313.75 313.75Z",
    fill: "#C5CBEB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M366.875 133.125H133.125C121.389 133.125 111.875 142.639 111.875 154.375V345.625C111.875 357.361 121.389 366.875 133.125 366.875H366.875C378.611 366.875 388.125 357.361 388.125 345.625V154.375C388.125 142.639 378.611 133.125 366.875 133.125ZM133.125 154.375H366.875V254.988L314.274 202.386L218.269 298.569L187.713 266.776L133.125 320.322L133.125 154.375ZM314.288 232.452L366.875 285.04V345.625H137.676L187.268 296.979L217.981 328.936L314.288 232.452Z",
    fill: "#C5CBEB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6992_31680"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 500,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDefault);
export default __webpack_public_path__ + "static/media/image-default.1b22822d.svg";
export { ForwardRef as ReactComponent };